/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
/** @docs-private */
export function getSbbFormFieldMissingControlError(): Error {
  return Error('sbb-form-field must contain a SbbFormFieldControl.');
}
